import { render, staticRenderFns } from "./chara-dialog.vue?vue&type=template&id=4c86a295&"
import script from "./chara-dialog.vue?vue&type=script&lang=js&"
export * from "./chara-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports